function AccessToggleCard({ title, description, toggle }) {
    return (
        <div className="bg-white border border-gray-200 rounded-xl p-4 flex flex-col gap-3">
            <div className="flex flex-row-reverse items-center justify-between">
                <p className="text-sm font-bold text-gray-800 rtol">{title}</p>
                {toggle}
            </div>
            <p className="text-xs text-gray-600 rtol">{description}</p>
        </div>
    );
}

export default AccessToggleCard;
